import React, { useState as uState, useEffect as uEffect } from 'react'
import { useNavigate as uNavigate } from 'react-router-dom'
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";

import Navbar from '../../Components/Navbar/navbar'
import Footer from '../../Components/Footer/footer'

import './userProfile.css'

export default function userProfile() {
  const navigate=uNavigate()
  const [delData, setDelData] = uState({})
  const [userData, setUserData] = uState({})

  const [image, setImage] = uState({
    profileImg: ''
  })
  const [upUser, setUpUser] = uState({
    name: '',
    nickname: '',
    email: '',
    mobile: '',
    address: '',
    profileImg: ''
  });



  const handleDelete = async (eve) => {
    if (localStorage.getItem('userEmail')) {
      eve.preventDefault()
      await fetch("http://localhost:8000/users/delete", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          delEmail: delData
        })
      }).then( () => {
        localStorage.removeItem('userEmail')
        localStorage.removeItem('authToken')
        navigate('/register')
      })
    } else {
console.log('error in deleting')
    }
  }
  const handleDeleteImage = async () => {
    if (localStorage.getItem('userEmail')) {
      await fetch("http://localhost:8000/users/imageDelete", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          deleteEmail:localStorage.getItem('userEmail') 
        })
      }).then(() => {
        window.location.reload()
        document.getElementById('deleteDiv').style.display = 'none'        
      })
    } else {
      console.log('error in deleting')
    }
  }


  const handlePhoto = (event) => {
    setImage({
      ...image,
      profileImg: event.target.files[0]

    })
  }

  const fetchMyUser = async () => {
    if (localStorage.getItem('userEmail')) {

      await fetch("http://localhost:8000/users/view", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: localStorage.getItem('userEmail')
        })
      }).then(async (res) => {
        const data = await res.json();
        setUserData(data);
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  const handleChange = (event) => {
    setUpUser({
      ...upUser,
      [event.target.name]: event.target.value,
    })
  }
  const handleUpdate = async (e) => {
    const oldmail = localStorage.getItem('userEmail');

    if (oldmail !== null) {
      e.preventDefault();

      const formData = new FormData();
      formData.append("name", upUser.name);
      formData.append("nickname", upUser.nickname);
      formData.append("mobile", upUser.mobile);
      formData.append("email", upUser.email);
      formData.append("address", upUser.address);
      formData.append("profileImg", image.profileImg);
      formData.append("oldmail", oldmail);

      const response = await fetch("http://localhost:8000/users/update", {
        method: "POST",
        body: formData
      });

      const json = await response.json();

      if (!json.success) {
        alert('error in sending data');
      } else {
        alert('records updated');
        localStorage.setItem('userEmail', upUser.email);
        window.location.reload();
      }

    } else {
      console.log('Failed to update details');
    }
  };

  const handleUp = () => {
    let upDiv = document.getElementById('upDiv')
    let delDiv = document.getElementById('delDiv')
    upDiv.style.display = 'flex'
    delDiv.style.display = 'none'
  }
  const handleDel = () => {
    let upDiv = document.getElementById('upDiv')
    let delDiv = document.getElementById('delDiv')
    delDiv.style.display = 'flex'
    upDiv.style.display = 'none'
  }

  uEffect(() => {
    fetchMyUser()
  }, [])

  return (
    <>
<Navbar/>
      <section style={{ backgroundColor: '#eee' }}>
        <div className="container py-5">

          <div className="row">
            <div className="col-lg-4">
                    <div className="card mb-4">
                      <div className="card-body text-center">
                    <img src={userData.profileImg ? `http://localhost:8000/public/userImages/${userData.profileImg}` : 'no image'} alt="avatar"
                      className="rounded-circle img-fluid" style={{ width: '150px' }} />
                        <h5 className="my-3">{userData.nickname}</h5>
                </div>
                {userData.profileImg ? <button id='deleteDiv' onClick={handleDeleteImage} className='btn btn-primary'>Delete Image Before Update</button> :'no image'}
                    </div>

              <div className="card mb-4 mb-lg-0">
                <div className="card-body p-0">
                  <ul className="list-group list-group-flush rounded-3">
                    <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                      <i className="fas fa-globe fa-lg text-warning"></i>
                      <p className="mb-0">Instagram</p>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                      <i className="fab fa-github fa-lg" style={{ color: '#333333' }}></i>
                      <p className="mb-0">Facebook</p>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                      <i className="fab fa-twitter fa-lg" style={{ color: '#55acee' }}></i>
                      <p className="mb-0">Twitter</p>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                      <i className="fab fa-instagram fa-lg" style={{ color: '#ac2bac' }}></i>
                      <p className="mb-0">Youtube</p>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center p-3">
                      <i className="fab fa-facebook-f fa-lg" style={{ color: '#3b5998' }}></i>
                      <p className="mb-0"></p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="card mb-4">
                {

                  Array(userData).map((item, index) => {
                    return (
                      <div key={index}>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-sm-3">
                              <p className="mb-0">Full Name</p>
                            </div>
                            <div className="col-sm-9">
                              <p className="text-muted mb-0">{item.name}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-3">
                              <p className="mb-0">Email</p>
                            </div>
                            <div className="col-sm-9">
                              <p className="text-muted mb-0">{item.email}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-3">
                              <p className="mb-0">Mobile</p>
                            </div>
                            <div className="col-sm-9">
                              <p className="text-muted mb-0">+91 {item.mobile}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-3">
                              <p className="mb-0">Address</p>
                            </div>
                            <div className="col-sm-9">
                              <p className="text-muted mb-0">{item.address}</p>
                            </div>
                          </div>
                          <hr />
                          <div className="row">
                            <div className="col-sm-3">
                              <p className="mb-0">Letter</p>
                            </div>
                            <div className="col-sm-9">
                              <p className="text-muted mb-0">{item.letter}</p>
                            </div>
                          </div>
                        </div>
                    </div>
                    )
                  })
                  
                }

              </div>
              <div className="row">
                <div className="d-flex justify-content-evenly col-md-12">
                  <button onClick={handleUp} className="btn btn-primary mb-0">Update</button>
                  <button onClick={handleDel} className="btn btn-primary mb-0">Delete</button>
                </div>
              </div>
              <form onSubmit={handleUpdate} encType='multipart/form-data' >
                <div id='upDiv' className="row">
                <div className="col-md-12">
                  <div className="card mb-4">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">Full Name</p>
                        </div>
                        <div className="col-sm-9">
                          <input required name='name' onChange={handleChange} value={upUser.name} className="text-muted mb-0" />
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">Nick Name</p>
                        </div>
                        <div className="col-sm-9">
                          <input required name='nickname' onChange={handleChange} value={upUser.nickname} className="text-muted mb-0" />
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">New Email</p>
                        </div>
                        <div className="col-sm-9">
                          <input required name='email' onChange={handleChange} value={upUser.email} className="text-muted mb-0" />
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">Mobile</p>
                        </div>
                        <div className="col-sm-9">
                          <input required name='mobile' onChange={handleChange} value={upUser.mobile} className="text-muted mb-0" />
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">Address</p>
                        </div>
                        <div className="col-sm-9">
                          <input required name='address' onChange={handleChange} value={upUser.address} className="text-muted mb-0" />
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">Profile Image</p>
                        </div>
                        <div className="col-sm-9">
                            <label htmlFor="profileImg">
                            Image: <DriveFolderUploadOutlinedIcon className="icon" />
                          </label>
                          <input required
                            name='profileImg'
                            accept=".png,.jpg,.jpeg"
                            type="file"
                            id="profileImg"
                            onChange={handlePhoto}
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-sm-9">
                          <button type='submit' className="btn btn-success mb-0">Update</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              </form>

              <form onSubmit={handleDelete} id='delDiv'  className="row">
                <div className="col-md-12">
                  <div className="card mb-4">
                    <div className="card-body">

                      <div className="row">
                        <div className="col-sm-3">
                          <p className="mb-0">Email</p>
                        </div>
                        <div className="col-sm-6">
                          <input required name='email'onChange={e=>setDelData(e.target.value)} value={delData.email} className="text-muted mb-0" />
                        </div>
                        <div className="col-sm-3">
                          <button type='submit' className="btn btn-danger mb-0">Delete</button>
                        </div>
                      </div> 

                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
<Footer/>

    </>
  )
}
